/**
 *
 *
 *
 *
 *
 *
 */
import { o_global } from "../common/namespaces";
import * as Lib from "../lib/storage/index.js";

export type * from "../lib/storage/index.js";

/**
 *
 */
export const storage: typeof Lib.storage = o_global.globalStorage;
